import * as tslib_1 from "tslib";
import { Injector, OnChanges, OnDestroy, SimpleChanges, ViewContainerRef, } from '@angular/core';
import { BaseAxesChart } from '@components/ui-chart/base-axes-chart';
import defaultsDeep from 'lodash-es/defaultsDeep';
import { BASE_SERIES_OPTIONS } from './ui-bar-chart.constants';
import { isBarChartDataComplexValue, } from './ui-bar-chart.types';
var UiBarChartComponent = /** @class */ (function (_super) {
    tslib_1.__extends(UiBarChartComponent, _super);
    function UiBarChartComponent(injector, _viewContainerRef) {
        var _this = _super.call(this, injector) || this;
        _this._viewContainerRef = _viewContainerRef;
        _this._getTooltipText = function (params) {
            if (_this.tooltipFormatter) {
                return _this.tooltipFormatter(params);
            }
            var currentValue = _this.data[params.dataIndex];
            var subtitle = isBarChartDataComplexValue(currentValue) && currentValue.tooltipName ?
                currentValue.tooltipName :
                params.name ?
                    params.name :
                    params.seriesName;
            var value = _this.valueFormatter ?
                _this.valueFormatter(params.value) :
                params.value;
            return "\n            <div class=\"chart-tooltip-container\">\n                <div class=\"tooltip-title\">\n                    <span class=\"tooltip-marker\">" + params.marker + "</span>\n                    <strong>" + value + "</strong>\n                </div>\n                <div class=\"tooltip-subtitle\">\n                    " + subtitle + "\n                </div>\n            </div>";
        };
        _this._mapData = function (rawData, index) {
            var value = isBarChartDataComplexValue(rawData) ?
                rawData.value :
                rawData;
            if (_this.xAxisLabels) {
                var dataSet = {
                    value: value,
                };
                if (_this.colors) {
                    dataSet.itemStyle = {
                        color: _this.colors[index] || null,
                    };
                }
                _this.chartOptions.series[0].data.push(dataSet);
                return;
            }
            var series = defaultsDeep({
                name: (_this.legend || [])[index] || '',
                data: [{ value: value }],
            }, BASE_SERIES_OPTIONS);
            if (_this.colors) {
                series.itemStyle = {
                    color: _this.colors[index] || null,
                };
            }
            _this.chartOptions.series.push(series);
            _this.chartOptions.legend.data.push({
                name: (_this.legend || [])[index] || '',
                icon: 'circle',
            });
        };
        _this.chartOptions.tooltip.formatter = _this._getTooltipText;
        return _this;
    }
    UiBarChartComponent.prototype.ngOnChanges = function (changes) {
        _super.prototype.ngOnChanges.call(this, changes);
        if (!this.data ||
            (!changes.data &&
                !changes.legend &&
                !changes.colors &&
                !changes.color &&
                !changes.xAxisLabels)) {
            return;
        }
        if (this.color != null &&
            this.colors.length) {
            throw new Error("The bar chart configuration only accepts usage of either 'color' or 'colors' component inputs.");
        }
        if (this.xAxisLabels != null &&
            this.showLegend) {
            // The component only supports simple bar charts and we're limited by how ECharts treats X axis labels and legend items.
            // An X axis label applies to all data items found at the same index in chartOptions.series[all].data[index]
            // A legend item applies to an entire chartOptions.series
            // Depending of which we want to show (X axis labels or legend), the chartOptions.series array will look differently.
            throw new Error("The bar chart configuration does not support both X Axis Labels and Legend at the same time.");
        }
        this.chartOptions.series = [];
        this.chartOptions.legend.data = [];
        this.chartOptions.xAxis.data = [];
        if (this.color != null) {
            this.chartOptions.color = [this.color];
        }
        if (this.xAxisLabels) {
            this.chartOptions.xAxis.data = this.xAxisLabels;
            this.chartOptions.series = [defaultsDeep({
                    data: [],
                }, BASE_SERIES_OPTIONS)];
        }
        this.data.forEach(this._mapData);
    };
    return UiBarChartComponent;
}(BaseAxesChart));
export { UiBarChartComponent };
